import { LangType } from '../lang/lang.slice';
import { SearchItem } from '../search/namespaces/responses';

export type UserType = {
	id: string;
	login: string;
	role: 'admin' | 'user' | 'operator' | 'manager' | '';
	timezone: string;
	language: LangType;
	comment: string;
	name: string;
	email: string;
	phoneNumber: string;
	parentUser?: string;
	accessRights?: string[];
	searchTags?: string[];
	searchHideTags?: string[];
	operatorTags?: string[];
	clientTags?: string[];
	fastManualTags?: string[];
	sttEngine?: string;
	sttLanguage?: string;
	sttModel?: string;
	sttEconomize?: boolean;
	sttCountPerIteration?: number;
	settings?: boolean;
	quotaRemindTime?: number;
	quotaTotalTime?: number;
	industry?: string | undefined;
	partner?: string | undefined;
};

export type ChildUserType = {
	id: string;
	role: string;
	login: string;
	name: string;
	timezone: string;
	parentUser?: string;
	quotaRemindTime?: number;
	quotaTotalTime?: number;
	industry?: string | undefined;
	partner?: string | undefined;
};

export type AccessRights = {
	search: boolean; // COMPLETE
	audio: boolean; // COMPLETE
	stt: boolean; // COMPLETE
	upload: boolean; // COMPLETE
	report: boolean; // COMPLETE
	report_manage: boolean;
	dictionary: boolean; // this
	tagging: boolean; // this
	notify: boolean; // LATER
	address_book: boolean; // LATER
	phone_number: boolean; // LATER
	tags: boolean; // LATER
	export: boolean;
	retag: boolean;
	restt: boolean;
	calls_actions: boolean;
	set_filter_user: boolean;
	add_user: boolean;
	add_operator: boolean;
	set_default_engine: boolean;
	admin: boolean;
	checklist: boolean;
	checklist_view: boolean;
	checklist_update: boolean;
	integration_view: boolean;
	integration_edit: boolean;
	delete_call: boolean;
	delete_user: boolean;
	delete_operator: boolean;
	import_foreign_rules: boolean;
	quota_view: boolean;
	quota_edit: boolean;
	gpt: boolean;
};

export enum AuthResponseErrors {
	FieldsRequired = 422,
	IncorrectData = 401,
}

export type QuotasType = {
	id: string;
	current: boolean;
	datetime_from: string | null;
	datetime_to: string | null;
	finished: boolean;
	given_by: string;
	owner: string;
	set_date: string;
	time_count: number;
	rest_time: number;
	time_nominal: number;

	idNumber?: number | string;
	given_by_name?: string;
};

export interface AccessRightType {
	key: string;
	title: string;
}

export interface ReportLimit {
	id: string;
	name: string;
}

export interface CallsLimitFilter {
	id: string;
	title: string | null;
	items: SearchItem[];
	isNew?: boolean;
}

export interface IPartnerIds {
	id: string;
	role: string;
	login: string;
	name: string;
	comment?: string;
	createdBy?: string;
	timezone?: string;
}
